import { archivalManagementApi } from "../../../api/apiClient";

function getChannels(data) {
  return archivalManagementApi.get("/channels", data);
}

function getChannel() {
  return archivalManagementApi.get(`/channels`);
}

function createChannel(data) {
  return archivalManagementApi.post("/channels", data);
}

function updateChannel(uuid, data) {
  return archivalManagementApi.post(`/channels/${uuid}`, data);
}

export const archivalManagementServices = {
  getChannels,
  getChannel,
  createChannel,
  updateChannel,
};
